import { IUpdateProjetoRevisaoResumoUseCase } from "../../../presentation/useCases/update/update_projeto_revisao_resumo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

export class UpdateProjetoRevisaoResumoUseCase implements IUpdateProjetoRevisaoResumoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async updateProjetoRevisaoResumo(idProjetoRevisaoResumo: number,
  idProjeto: number | null,      
  idDisciplina: number | null,   
  descricao: string | null,      
  responsavel: string | null,    
  idFuncionario: number | null,  
  data: Date | null): Promise<void> {
    return await this.repository.updateProjetoRevisaoResumo(idProjetoRevisaoResumo, idProjeto, idDisciplina, descricao, responsavel, idFuncionario, data);
  }
}
